import { apiClient } from "./client";

const PassengerInfoByBrokerGroupId = (brokerGroupId) => {
  return apiClient
    .get("/PassengerInfo/PassengerInfoByBrokerGroupId", {
      params: {
        'brokerGroupId': brokerGroupId
      }
    });
}
const GetPassengerInfoBySSN = (ssn) => {
  return apiClient
    .get("/PassengerInfo/GetPassengerInfoBySSN", {
      params: {
        'ssn': ssn
      }
    });
}

const passengerInfoApi = { PassengerInfoByBrokerGroupId, GetPassengerInfoBySSN }
export default passengerInfoApi;